/** The items that link to an item, grouped as its page shows them. */
import type { Backref, Field, PageItemRow } from "../api/types.gen.ts";
import { type LinkValues, linkId, linkValues } from "./links.ts";

/** One group: the items of an entity (none: untyped) linking here through one ref field. */
export interface BackrefGroup {
  entity: string | null;
  key: string;
  count: number;
}

/** A group's link columns: the ref field's link fields (values carried on each link, like bottles per wine). */
export interface LinkColumns {
  /** The item linked to. */
  to: string;
  /** The ref field linking. */
  key: string;
  fields: readonly Field[];
}

/** The groups of `refs`, the largest first (then as they came). */
export function groupsOf(refs: readonly Backref[]): BackrefGroup[] {
  const groups = new Map<string, BackrefGroup>();
  for (const b of refs) {
    const entity = b.entity ?? null;
    const id = `${entity ?? ""}:${b.key}`;
    const g = groups.get(id) ?? { entity, key: b.key, count: 0 };
    g.count += 1;
    groups.set(id, g);
  }
  return [...groups.values()].sort((a, b) => b.count - a.count);
}

/** The values a row's link to `cols.to` carries, by link field. */
export function carriedValues(row: PageItemRow["data"][number], cols: LinkColumns): LinkValues {
  const link = row.refs?.[cols.key]?.find((l) => linkId(l) === cols.to);
  return link ? linkValues(link) : {};
}
